import { professor as schemaProfessor } from './schemas';
import apiClient from './apiClient';
import ProfessorDataStore from '../../datastores/ProfessorDataStore';
import IDHelpers from '../../../core/helpers/IDHelper';

class ProfessorDataStoreGraphQL implements ProfessorDataStore {
  client = apiClient();

  async getProfessors() {
    try {
      const response = await this.client.query({
        query: schemaProfessor.getProfessors
      });
      const { coursesApp } = response?.data;
      const arrProfessors: any[] = [];
      coursesApp?.schedule?.forEach((course: any) => {
        course?.professors?.forEach((prof: any) => {
          const id = IDHelpers.generateID();
          arrProfessors.push({
            id: id.toString(),
            code: id.toString(),
            firstName: prof?.firstName,
            lastName: prof?.lastName,
            email: '',
            type: '',
            photo: '',
            phone: '',
            courseId: course.id
          });
        });
      });
      return arrProfessors;
    } catch (error) {
      throw new Error('error professors');
    }
  }
}
export default ProfessorDataStoreGraphQL;
